import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredVolatilityMedium = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={26}
    fill="none"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#a)">
      <rect
        width={7.5}
        height={21}
        x={7.5}
        y={22.5}
        fill="#8094B1"
        rx={1}
        transform="rotate(-180 7.5 22.5)"
      />
      <path
        fill="url(#b)"
        d="M10.5 11.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-10Z"
      />
      <rect width={4.5} height={7.636} x={19.5} y={15} fill="url(#c)" rx={1} />
    </g>
    <path
      fill="url(#d)"
      d="M30.347 6.203h2.232l3.287 9.396 3.287-9.396h2.233L36.763 19H34.97L30.347 6.203Zm-1.204 0h2.223l.404 9.158V19h-2.627V6.203Zm11.223 0H42.6V19h-2.637v-3.639l.404-9.158Zm13.131 10.74V19h-6.812v-2.057h6.812Zm-5.95-10.74V19H44.91V6.203h2.637Zm5.062 5.212v2.004h-5.924v-2.004h5.924Zm.88-5.212V8.27h-6.803V6.203h6.802ZM58.963 19h-2.786l.017-2.057h2.769c.691 0 1.274-.155 1.749-.466.474-.316.832-.776 1.072-1.38.246-.603.37-1.332.37-2.188v-.624c0-.656-.071-1.233-.212-1.731-.134-.498-.337-.917-.606-1.257-.27-.34-.6-.595-.993-.765-.393-.176-.844-.263-1.354-.263h-2.865V6.203h2.865c.856 0 1.638.147 2.347.44.715.287 1.333.7 1.854 1.239a5.54 5.54 0 0 1 1.204 1.933c.288.745.431 1.574.431 2.488v.606c0 .908-.143 1.737-.43 2.487a5.54 5.54 0 0 1-1.205 1.934 5.343 5.343 0 0 1-1.854 1.24c-.715.286-1.506.43-2.373.43ZM57.672 6.203V19h-2.637V6.203h2.637Z"
    />
    <defs>
      <linearGradient
        id="b"
        x1={0.9}
        x2={23.8}
        y1={0.75}
        y2={3.813}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E80032" />
        <stop offset={1} stopColor="#FFF347" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={0.75}
        x2={24.745}
        y1={5.25}
        y2={6.577}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E80032" />
        <stop offset={1} stopColor="#FFF347" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={25.077}
        x2={79.076}
        y1={3.792}
        y2={34.263}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E80032" />
        <stop offset={1} stopColor="#FFF347" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredVolatilityMedium)
const IconSvgColouredVolatilityMedium = createIcon(
  ForwardRef,
  'SvgColouredVolatilityMedium',
)
export default IconSvgColouredVolatilityMedium
